import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Home from '../pages/Home'
import About from '../pages/About'
import Gallery from '../pages/Gallery'
import ProductListing from '../pages/ProductListing'
import ProductDetails from '../pages/ProductDetails'
import Contact from '../pages/Contact'
import NotFound from '../pages/NotFound'

const Routers = () => {
  return <Routes>
    <Route path='/' element={<Navigate to='/home' />} />
    <Route path='/home' element={<Home/>} />
    <Route path='/about' element={<About/>} />
    <Route path='/product/:slug' element={<ProductDetails/>} />
    <Route path='/product-category/:slug' element={<ProductListing/>} />
    <Route path="/gallery" element={<Gallery />} />
    <Route path="/contact" element={<Contact />} />
    <Route path='/not-found' element={<NotFound/>} />
    
  </Routes>
}

export default Routers
